<script setup lang="ts">
import { cn } from '@/lib/utils'
import { ChevronDown } from 'lucide-vue-next'
import { AccordionHeader, AccordionTrigger, type AccordionTriggerProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<AccordionTriggerProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
})
</script>

<template>
    <AccordionHeader class="flex">
        <AccordionTrigger
            v-bind="delegatedProps"
            :class="
                cn(
                    'items-cente flex flex-1 justify-between p-4 text-left text-sm font-medium transition-all [&[data-state=open]>svg]:rotate-180',
                    props.class,
                )
            "
        >
            <slot />
            <slot name="icon">
                <ChevronDown class="size-6 shrink-0 transition-transform duration-200" />
            </slot>
        </AccordionTrigger>
    </AccordionHeader>
</template>
